/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-loop-func */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-undef */
import React from "react";
import { connect } from "react-redux";
import { Link, useParams, useNavigate } from "react-router-dom";
import {
	FeatherIcon,
	getIcon,
	retrieveFromStorage,
} from "../../Components/Functions";
import Layout from "../../Components/Layout";
import { routers } from "../../Constants/routers";
import {
	updateChatHistory,
	updateChatHistoryView,
	updateChatList,
	updateChatView,
} from "../../Redux/Chats/actions";
import { USER_AUTHENTICATION_DATA } from "../../Redux/User/types";
import { updateWebsockets } from "../../Redux/Websockets/actions";
import Api from "../../Server/Api";
import ChatBody from "./ChatBody";
import DesktopChatList from "./chatlist/DesktopChatList";
import MobileChatList from "./chatlist/MobileChatList";
import MobileChatList2 from "./chatlist/MobileChatList2";
import { composeChat, initMessaging } from "./mesaging";
import { AppSocket, eventsName } from "./websocket";

const { user } = retrieveFromStorage(USER_AUTHENTICATION_DATA) || {};
export const loggedUser = user || {};

const api = new Api();
let websocket = null;
let websockets = [];

const Messanger = (props) => {

	let { currentUser } = useParams();

	let navigate = useNavigate();

	React.useEffect(() => {
		if(currentUser){
			if (currentUser !== routers.dashboard.newconversation.name) {
				connectUser(currentUser);
				props.updateChatHistory({ ...props?.chathistory }, currentUser);
				setCollapse1(false);
			}else{
				props.updateChatView({ ...props.chats })
				props.updateChatHistoryView({ 
					results: [],
					user: null
				})
			}
		}
	}, [currentUser]);

	const [collapse, setCollapse] = React.useState(false);
    const [collapse1, setCollapse1] = React.useState( (!props?.chathistory?.user?.username ? true : false));


	const fetchChatWith = (a) => {
		navigate(routers.dashboard.messanger(a))
	};

	const updateList = () => {
		props.updateChatList(props?.chats, (e) => { setupConnections(e) });
	};

	const [events, setEvents] = React.useState();

	React.useEffect(() => {
		if (events) {
			switch (events.name) {
				case eventsName.connectionStatus:
					updateUserStatus(events.props);
					break;
				case eventsName.newIncomingMessage:
					newIncomingMessage(events.props);
				default:
					break;
			}
		}
	}, [events]);


    const getViewUser = () => {
        return props?.chathistory?.user || {};
    }

	// CHAT EVENTS ACTIVITIES
	const updateUserStatus = ({ username, obj }) => {
		let user = props?.chats?.chatlist?.find((e) => e.username === username);
		if (user) {
			const userIndex = props?.chats?.chatlist?.findIndex(
				(e) => e.username === username,
			);
			user = { ...user, ...obj };
			let chatlist = props?.chats?.chatlist;
			chatlist[userIndex] = user;
			props.updateChatView({ ...props?.chats, chatlist });
		}
	};
	

	const newIncomingMessage = (data) => {
		const a = getViewUser()?.username;
		if (data?.sender === a) {
            updateCurrentChatView({...data?.message, sender: "other"})
		}else{
			let user = props?.chats?.chatlist?.find((e) => e.username === data?.sender);
			if(user){
				const mp3 = require("../../assets/mp3/ringer.mp3").default
				new Audio(mp3).play()
				const _data = {
					unread: user?.unread ? user?.unread + 1 : 1
				}
				updateUserStatus({ username: data?.sender, obj: _data })
			}
		}
	};

    const updateCurrentChatView = (message) => {
        let new_results = [...props?.chathistory?.results, message];
        const d = {
            ...props.chathistory,
            results: new_results,
        };
        props.updateChatHistoryView(d)
    }

	const getChatId = (username) => {
		if (loggedUser.role === "SPECIALIST") {
			return `${loggedUser?.username}-${username}`;
		}
		return `${username}-${loggedUser?.username}`;
	};

	const connectUser_ = (username) => {
		const connectionId = getChatId(username);
		if (websocket) {
            return websocket;
		}
		const data = {
			id: connectionId,
			self: loggedUser?.username,
			other: username,
		};
		websocket = new AppSocket({ id: connectionId, ...data, setEvents });
		return websocket;
	};

	const setupConnections = (users = []) => {
		users.forEach((e) => { connectUser(e.username) });
	}

	const connectUser = (username) => {
		const connectionId = getChatId(username);
		if (websocket) {
			const net = websockets.find((e) => e.id === connectionId)
            return net.websocket;
		}
		const data = {
			id: connectionId,
			self: loggedUser?.username,
			other: username,
		};
		websocket = new AppSocket({ id: connectionId, ...data, setEvents });
		websockets.push({ id: connectionId, websocket })
		return websocket;
	};

	React.useEffect(() => {
		updateList();
        initMessaging({ fetchChatWith });
	}, []);

	const [message, setMessage] = React.useState();

	// MESSAGING
	const sendMessage = () => {
		if (message) {

			const receiver = getViewUser()?.username;
            const sender = loggedUser?.username;

			const msg = composeChat({
				sender: sender,
				avatar: loggedUser?.image,
				type: "msg",
				text: message,
			});
            updateCurrentChatView(msg);
			connectUser(receiver).sendMessage({ receiver, sender, message: msg });
			document.getElementById("chat-input").value = "";
		}
	};


	return (
		<Layout layout={2}>
			<div
				id="messages-sidebar"
				className={`sidebar-panel is-messages ${collapse ? "" : "is-active"}`}
			>
				<div className="messages-header">
					<h3 className="no-mb">Chat</h3>
					<div
						className="huro-hamburger nav-trigger push-resize messages-push"
						data-sidebar="messages-sidebar"
					>
						<span className="menu-toggle has-chevron"
                            onClick={() => setCollapse(!collapse)}
                        >
							<span className={`icon-box-toggle ${collapse ? "" : "active"}`}>
								<span className="rotate">
									<i className="icon-line-top" />
									<i className="icon-line-center" />
									<i className="icon-line-bottom" />
								</span>
							</span>
						</span>
					</div>
				</div>
				<div className="inner">
					{loggedUser?.role === "SPECIALIST" && (
                        <div className="is-new-conversation">
						<Link
							to={routers.dashboard.newconversation.url}
							id="start-conversation"
							className="start-conversation button h-button is-primary is-raised is-rounded is-fullwidth"
							dangerouslySetInnerHTML={{
								__html: getIcon("plus") + "<span>New Conversation</span>",
							}}
                            // onClick={() => setCurrentUser()}
 						/>
					</div>
                    )}
					
                    <DesktopChatList viewChat={getViewUser()} />
				</div>
			</div>
			<div className={`mobile-subsidebar is-messaging ${ window.innerWidth < 800 ? "" : collapse ? "" : "is-active"}`}>
				<div className="inner">
					<div className="sidebar-title">
						<h3>Messages</h3>
					</div>
					<MobileChatList2 />
				</div>
			</div>
			<div className={`collapsed-messaging ${collapse ? "is-active":""}`}>
				<div className="inner">
					<div className="collapsed-menu">
						<div
							className="huro-hamburger nav-trigger push-resize messages-push"
							data-sidebar="messages-sidebar"
						>
							<span className="menu-toggle has-chevron"
                                onClick={() => setCollapse(!collapse)}
                            >
								<span className={`icon-box-toggle ${collapse ? "":"active"}`}>
									<span className="rotate">
										<i className="icon-line-top" />
										<i className="icon-line-center" />
										<i className="icon-line-bottom" />
									</span>
								</span>
							</span>
						</div>
					</div>
                    {loggedUser?.role === "SPECIALIST" && (
					<div className="collapsed-add">
						<Link
							id="start-conversation"
                            to={routers.dashboard.newconversation.url} 
                            className="start-conversation button collapse-add-button is-primary" 
                            dangerouslySetInnerHTML={{ __html: getIcon("plus") }}

                        />
					</div>
                    )}
					<MobileChatList viewChat={getViewUser()} />
				</div>
			</div>
			<div
				id="huro-messaging"
				className={`view-wrapper ${collapse ? "is-pushed-messages" : "is-pushed-full"}`}
				data-sidebar-open
				data-naver-offset={406}
				data-menu-item="#sidebar-bubble"
				data-mobile-item="#mobile-bubble"
			>
				<div className="page-content-wrapper">
					<div className="page-content chat-content">
						<div className="page-title has-text-centered is-hidden">
							<div
								className="huro-hamburger nav-trigger push-resize"
								data-sidebar="messages-sidebar"
							>
								<span className="menu-toggle has-chevron">
									<span className="icon-box-toggle">
										<span className="rotate">
											<i className="icon-line-top" />
											<i className="icon-line-center" />
											<i className="icon-line-bottom" />
										</span>
									</span>
								</span>
							</div>
							<h1 className="title is-5">Messages </h1>
						</div>
						{/* Chat Card */}
						<div className="is-chat animated preFadeInUp fadeInUp">
							{/* Header */}
							<div className="chat-header" style={{ display:  currentUser === routers.dashboard.newconversation.name ? "" : "none" }}>
								<div className={`is-autocomplete ${currentUser ? "is-hidden" :""}`}>
									<div className="control">
										<input
											id="users-autocpl"
											type="text"
											className="input"
											placeholder="Start typing a name"
											autofocus
										/>
										<div className="icon">
											<span>To:</span>
										</div>
										<div
											className="hide"
											dangerouslySetInnerHTML={{ __html: getIcon("x") }}
										></div>
									</div>
								</div>
							</div>
							<ChatBody 
                                collapse1={collapse1}
                                setCollapse1={setCollapse1}
                            />
							{props?.chathistory?.user && (
							<div className={`message-field-wrapper ${collapse1 ? "side-collapsed" : ""}`}>
								<div className="control">
									<div className="add-content">
										<div className="dropdown dropdown-trigger is-up">
											<div>
												<div
													className="button"
													aria-haspopup="true"
													dangerouslySetInnerHTML={{ __html: getIcon("plus") }}
												></div>
											</div>
											<div className="dropdown-menu" role="menu">
												<div className="dropdown-content">
													<a className="dropdown-item">
														<FeatherIcon icon="video" />
														<div className="meta">
															<span>Video</span>
															<span>Embed a video</span>
														</div>
													</a>
													<a
														href="#"
														className="dropdown-item kill-drop h-modal-trigger"
													>
														<FeatherIcon icon="image" />
														<div className="meta">
															<span>Images</span>
															<span>Upload pictures</span>
														</div>
													</a>
													<a
														href="#"
														className="dropdown-item kill-drop h-modal-trigger"
													>
														<FeatherIcon icon="link" />
														<div className="meta">
															<span>Link</span>
															<span>Post a link</span>
														</div>
													</a>
													<hr className="dropdown-divider" />
													<a
														href="#"
														className="dropdown-item kill-drop h-modal-trigger"
													>
														<FeatherIcon icon="file" />
														<div className="meta">
															<span>File</span>
															<span>Upload a file</span>
														</div>
													</a>
												</div>
											</div>
										</div>
									</div>
									<div className="add-emoji">
										<div
											className="button"
											dangerouslySetInnerHTML={{ __html: getIcon("smile") }}
										></div>
									</div>
									<form
										onSubmit={(e) => {
											e.preventDefault();
											sendMessage();
										}}
									>
										<input
											id="chat-input"
											className="input is-rounded"
											type="text"
											placeholder="Write a message ..."
											onInput={(e) => setMessage(e.target.value)}
                                            autocomplete={"off"}
										/>
									</form>
									<div className="send-message">
										<div
											className="button h-button is-primary is-raised is-rounded"
											onClick={sendMessage}
										>
											Send
										</div>
									</div>
								</div>
								<div className="typing-indicator">
									<img
										src="https://huro.cssninja.io/assets/img/icons/typing.gif"
										alt
									/>
								</div>
							</div>
							)}
						</div>
						<div className="is-chat-placeholder animated preFadeInUp fadeInUp is-hidden">
							<div className="caption">
								<img
									src="https://via.placeholder.com/150x150"
									data-demo-src="https://huro.cssninja.io/assets/img/illustrations/messages/empty-placeholder.svg"
									alt=""
								/>
								<div className="text">
									<h3>Nothing to show</h3>
									<p>Select an existing conversation or start a new one</p>
									<a
										id="new-chat"
										className="button h-button is-solid is-outlined is-big is-rounded"
									>
										Start a new conversation
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			{props?.chathistory?.user && (
			<a className={`chat-side-fab ${collapse1 ? "is-active" : "is-mobile-active"}`}
                dangerouslySetInnerHTML={{ __html: getIcon("chevron-left") }}
                onClick={() => setCollapse1(!collapse1)}
            />
			)}
		</Layout>
	);
};

const mapStateToProps = ({ user, chats, websocket, chathistory }) => {
	return { user, chats, websocket, chathistory };
};

const mapDispatchToProps = (dispatch) => {
	return {
		updateChatList: (e, c) => dispatch(updateChatList(e, c)),
		updateChatHistory: (e, u) => dispatch(updateChatHistory(e, u)),
		updateWebsockets: (e) => dispatch(updateWebsockets(e)),
		updateChatView: (e) => dispatch(updateChatView(e)),
		updateChatHistoryView: (e) => dispatch(updateChatHistoryView(e)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Messanger);
